export default __webpack_public_path__ + "static/IKB_Logo_CMYK_Rot_Schwarz_300dpi-42f69b4ef508b7101997982d98b2464d.png";